import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Container, Headline, sizes } from '../ui/common';
import useWindowSize from '../../../utils/useWindowSize';
import {
  Section,
  List,
  Block,
  Card,
  Cell,
  Title,
  Value,
  Image,
  ImageWrap,
  Wrap,
} from './styled';
import defaultList from './data';
import specs from '../Specifications/data';
import { colors } from '../../../ui/common';

function Difference({ info, images, list }) {
  const size = useWindowSize();
  const Wrapper = size.width < sizes.medium ? Wrap : Container;
  const getIcon = (value) => (
    <svg
      width="24"
      height="23"
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="22.8474"
        y1="11.1305"
        x2="1.15221"
        y2="11.1305"
        stroke={colors.color01}
        strokeLinecap="round"
      />
      {value && (
        <line
          x1="11.4402"
          y1="0.845314"
          x2="11.4402"
          y2="22.4093"
          stroke={colors.color01}
          strokeLinecap="round"
        />
      )}
    </svg>
  );

  const productTag = info.url;
  const product = {
    [productTag]: `difference.evapolar.desc.${productTag}`,
    electricity: specs[productTag].power,
    freon: false,
    humidify: true,
    portable: true,
    noisiness: false,
    design: true,
  };

  const listWrapped = list || [product, ...defaultList];

  return (
    <Section>
      <Wrapper>
        <Headline>
          <FormattedMessage id="difference.headline" />
        </Headline>
        <List>
          {listWrapped.map((options, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <Block key={i}>
              <Card>
                <ImageWrap>
                  <Image image={images[i]} alt="" />
                </ImageWrap>
                {Object.keys(options).map((key, index) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <Cell key={index} isFirst={index === 0}>
                    <Title>
                      <FormattedMessage id={`difference.title.${key}`} />
                    </Title>
                    <Value>
                      {typeof options[key] === 'boolean' ? (
                        getIcon(options[key])
                      ) : (
                        <FormattedMessage id={options[key]} />
                      )}
                    </Value>
                  </Cell>
                ))}
              </Card>
            </Block>
          ))}
        </List>
      </Wrapper>
    </Section>
  );
}

export default Difference;

Difference.propTypes = {
  images: PropTypes.arrayOf(PropTypes.any),
  info: PropTypes.objectOf(PropTypes.any).isRequired,
  list: PropTypes.arrayOf(PropTypes.any),
};

Difference.defaultProps = {
  images: [],
  list: null,
};
